<template>
  <div v-if="showNoDataImgForUser">
    <div class="progressImgDataContainer">
      <div class="progressDataText">
        <h4>Your data has been successfully added to Weavr!</h4>
        <p>Please check back in 24 hours.</p>
      </div>
      <div class="progressImgWrapper">
        <img
          src="Icons_SVG/progressDataImgUpdated.svg"
          alt="data in progress"
        />
      </div>
    </div>
  </div>
  <div v-else id="brand-reviews">
    <div
      v-show="
        reviewsLoader ||
        sentimentsLoader ||
        modalLoader ||
        sentimentsLoader1 ||
        loaderUpdated
      "
    >
      <Loader />
    </div>
    <div>
      <div
        class="card datepickerwrap mt-4 d-flex flex-row justify-content-between"
      >
        <div class="d-flex flex-row gap">
          <div>
            <div class="mb-1 ml-1 label">{{ translatedLang["Date Range"][selectedLanguage.key] }}</div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDate"
              :max-date="maxDate"
              :ranges="false"
            >
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon"
            v-if="platforms.length"
            style="min-width: 170px; max-width: 200px"
          >
            <!-- <div class="mb-1 ml-1 label">Platform</div> -->
            <!-- <select v-model="selectedPlatform" class="form-control text-capitalize platform-select">
                            <option v-for="platform of platforms" :key="platform.platform_link" :value="platform"
                                class="text-capitalize">
                                {{ platform.platform_name.replaceAll("_", " ") }}
                            </option>
                        </select> -->
            <!-- @input="changePlatformForBrandSelection" -->
            <!-- <div class="" v-if="platforms.length"> -->
            <div class="mb-1 ml-1 label">{{ translatedLang["Platform"][selectedLanguage.key] }}</div>
            <div class="">
              <multiselect
                v-model="selectedPlatform"
                :custom-label="updateSelectedLabels"
                @input="changePlatformForBrandSelection"
                :options="platforms"
                :multiple="false"
                :searchable="false"
                placeholder="Select Platform"
                label="platform_name"
                track-by="platform_id"
                :showLabels="false"
                :close-on-select="true"
                class="text-capitalize"
              >
                <template #option="{ option }">
                  <div class="custom-option text-capitalize">
                    {{ option.platform_name.replaceAll("_", " ") }}
                  </div>
                </template>
              </multiselect>
            </div>
            <!-- </div> -->
          </div>
          <!-- <div class="customSelect" v-if="!compareBrands">
                        <div class="mb-1 ml-1 label">Brand</div>
                        <select v-model="selectedGlobalBrand" class="form-control text-capitalize platform-select">
                            <option v-for="brand of allBrands[selectedPlatform.platform_name]" :key="brand.id"
                                :value="brand" class="text-capitalize">
                                {{ brand.label.replaceAll("_", " ") }}
                            </option>
                        </select>
                    </div> -->
          <div class="customMultiselectCommon" v-if="!compareBrands">
            <div class="mb-1 ml-1 label">{{ translatedLang["Brand"][selectedLanguage.key] }}</div>
            <div class="" style="width: 150px">
              <multiselect
                v-model="selectedGlobalBrand"
                :options="allBrands[selectedPlatform.platform_id] || []"
                :multiple="false"
                :searchable="false"
                placeholder="Select Brand"
                label="label"
                track-by="id"
                :showLabels="false"
                :close-on-select="true"
                class="text-capitalize"
              >
                <!-- <template #option="{ option }">
                                    <div class="custom-option text-capitalize">
                                        {{ option }}
                                    </div>
                                </template> -->
              </multiselect>
            </div>
          </div>
          <div
            class="d-flex flex-row align-items-center gap"
            style="margin-top: 20px"
          >
            <!-- Filter and Download Buttons -->
            <button @click="refresh" class="btn primarycolor">
                {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
            </button>
            <button
              @click="activateComparison"
              class="btn primarycolor"
              v-show="!compareBrands"
            >
            {{ translatedLang["Compare"][selectedLanguage.key] }}
            </button>
           
          </div>
        </div>
        <div class="d-flex align-items-center" style="margin-top: 20px">
          <button @click="downloadReviews" class="btn primarycolor">
            {{ translatedLang["Download"][selectedLanguage.key] }}
          </button>
           <button
              @click="deactivateComparison"
              class="btn navigation-btn tw-ml-2"
              v-show="compareBrands"
            >
            {{ translatedLang["Back"][selectedLanguage.key] }}
            </button>
        </div>
        
      </div>
      <div class="card" v-if="compareBrands">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex justify-content-start mt-2" v-if="selectedView">
            <div class="graphHeading pb-2 mr-3">
              {{ selectedView.view_name }}
            </div>
            <div class="cursor-pointer" @click="openViewModal('Edit View')">
              <img
                src="../../../public/Icons_SVG/editBtn.svg"
                style="width: 15px; height: 15px"
              />
            </div>
            <div class="cursor-pointer ml-3" @click="showDeleteModal = true">
              <img
                src="../../../public/Icons_SVG/deleteBtnSvg.svg"
                style="width: 15px; height: 15px"
              />
            </div>
          </div>
          <div class="grayedHeading pb-2 mr-3 mt-2" v-else>{{ translatedLang["Unsaved View"][selectedLanguage.key] }}</div>
          <div class="d-flex justify-content-end align-items-end">
            <div style="margin-inline: 0.5rem">
              <div
                class="mb-1 ml-1"
                style="font-size: 14px; font-weight: 400; color: #1e1e1e"
              >
              {{ translatedLang["Select View Name"][selectedLanguage.key] }}
              </div>
              <div
                class="customMultiselect"
                style="width: 250px; margin-bottom: -5px"
              >
                <multiselect
                  v-model="selectedView"
                  :options="viewOptions"
                  :multiple="false"
                  :searchable="false"
                  placeholder="Select View"
                  label="view_name"
                  track-by="view_id"
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  @input="getSelectedSavedView"
                >
                </multiselect>
              </div>
            </div>
            <div class="d-flex align-items-end">
              <button
                @click="resetSavedView"
                class="btn primarycolor mr-2 d-flex item-items-center"
              >
                <span class="newComparisonIcon">
                  <svg
                    focusable="false"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    ></path>
                  </svg>
                </span>
                <span>{{ translatedLang["Add New View"][selectedLanguage.key] }}</span>
              </button>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <button
                class="btn navigation-btn"
                @click="openViewModal('Save View')"
              >
                <span>{{ translatedLang["Save View"][selectedLanguage.key] }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card mx-2" v-if="!compareBrands">
        <b-row no-gutters>
          <b-col cols="8" class="vertical-divider pr-3">
            <BrandIndicator
              level="brand"
              :indicatorName="marketShare.brand"
              :brandIndicators="marketShare"
            />
            <div>
              <div class="my-4 d-flex flex-row gap">
                <!-- Button Groups for date filtering -->
                <button
                  type="button"
                  v-for="filterState of reviewFilterState"
                  :key="filterState"
                  class="section-button"
                  :class="
                    selectedFilterState === filterState ? 'active-button' : ''
                  "
                  @click="filterCustomDate(filterState)"
                >
                  {{ translatedLang[filterState][selectedLanguage.key] || filterState }}
                </button>
              </div>
              <b-row class="mt-4" no-gutters>
                <b-col cols="6" class="pr-3">
                  <div
                    class="section-card"
                    v-if="Object.keys(ratingsData).length"
                  >
                    <ReviewsAndRatings :ratingsData="ratingsData" />
                  </div>
                  <div v-else class="section-card">
                    <p class="heading">{{ translatedLang["Overall Rating"][selectedLanguage.key] }}</p>
                    <noData
                      :loaderVariable="prodcutReviewAPILoading"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </b-col>
                <b-col cols="6">
                  <div
                    class="section-card"
                    v-if="Object.keys(sentimentsCount).length"
                  >
                    <Sentiments
                      :sentimentsData="sentimentsCount"
                      :navigation="true"
                      @navigate-to-sentiment-details="
                        navigateWordCloud('sentiments-detail')
                      "
                    />
                  </div>
                  <div v-else class="section-card">
                    <p class="heading">{{ translatedLang["Customer Sentiments"][selectedLanguage.key] }}</p>
                    <noData
                      :loaderVariable="sentimentsLoader1"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-3" v-if="performanceData.length">
                <b-col cols="12" v-if="performanceData.length">
                  <PerformanceChart
                    heading="Brand"
                    :showTabs="true"
                    :performanceData="performanceData"
                    :performanceRatingsData="performanceRatingsData"
                  />
                </b-col>
              </b-row>
              <b-row class="mt-3" v-else>
                <b-col cols="12">
                  <div class="section-card">
                    <p class="heading">{{ translatedLang["Brand Performance"][selectedLanguage.key] }}</p>
                    <noData
                      :loaderVariable="prodcutReviewAPILoading || sentimentsLoader"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col
            cols="4"
            class="pl-3"
            style="
              background: linear-gradient(
                180deg,
                rgba(255, 255, 255, 0) 94.69%,
                rgba(14, 14, 14, 0.1) 100%
              );
            "
          >
            <LogoContainer
              :brandContainer="true"
              :brandName="client"
              :imgSrc="brandImage"
            />
            <div class="mt-2">
              <div class="review-heading">
                <div id="border"></div>
                <div id="heading">{{ translatedLang["Review Summary"][selectedLanguage.key] }}</div>
              </div>
              <div class="section-card my-3 px-4 py-3">
                <div
                  style="font-size: 15px; font-weight: 600; letter-spacing: 0"
                >
                {{ translatedLang["What customers say"][selectedLanguage.key] }}:
                </div>
                <div class="py-2">
                  {{ aiReviewSummary }}
                </div>
                <div style="font-family: Heebo; color: #5e5e5e" class="pb-2">
                  {{ translatedLang["AI-generated from the text of customer reviews"][selectedLanguage.key] }}
                </div>
              </div>
            </div>
            <LatestReviews :latestReviews="reviewsData" :isLoadingData="prodcutReviewAPILoading" parentClasses="mt-2" />
          </b-col>
        </b-row>
        <!-- <section id="sentiments-detail" class="mt-3">
          <b-row no-gutters>
            <b-col cols="6" class="pr-2">
              <div
                class="section-card"
                v-if="Object.keys(wordCloudData).length"
              >
                <div
                  class="d-flex justify-content-between align-items-center heading"
                >
                  <p class="mb-0"> {{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                  <div class="customSelect">
                    <select
                      class="form-control text-capitalize platform-select"
                      v-model="selectedPositiveCloudLimit"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
                <div v-if="wordCloudData.positive.length">
                  <WordCloud
                    :cloudData="
                      wordCloudData.positive.slice(
                        0,
                        selectedPositiveCloudLimit
                      )
                    "
                    color="#065559"
                    @analyse-keyword="openNegativeModal"
                  />
                </div>
                <div v-else class="noData"> {{ translatedLang["No Data"][selectedLanguage.key] }}</div>
              </div>
            </b-col>
            <b-col cols="6" class="pl-1">
              <div
                class="section-card"
                v-if="Object.keys(wordCloudData).length"
              >
                <div
                  class="d-flex justify-content-between align-items-center heading"
                >
                  <p class="mb-0">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                  <div class="customSelect">
                    <select
                      class="form-control text-capitalize platform-select"
                      v-model="selectedNegativeCloudLimit"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
                <div v-if="wordCloudData.negative.length">
                  <WordCloud
                    :cloudData="
                      wordCloudData.negative.slice(
                        0,
                        selectedNegativeCloudLimit
                      )
                    "
                    color="#FD5542"
                    @analyse-keyword="openNegativeModal"
                  />
                </div>
                <div v-else class="noData">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
              </div>
            </b-col>
          </b-row>
        </section> -->
        <!-- <b-row no-gutters>
          <b-col cols="8" class="pb-4 pr-2">
            <div class="section-card mt-3">
              <p class="heading">{{ translatedLang["All Sentiments"][selectedLanguage.key] }}</p>
              <div class="thin-scroller">
                <table
                  class="w-100 mt-4"
                  id="sentiments-table"
                  v-if="sentimentsTable.length"
                >
                  <thead>
                    <tr>
                      <th>{{ translatedLang["Keyword"][selectedLanguage.key] }}</th>
                      <th>{{ translatedLang["Frequency"][selectedLanguage.key] }}</th>
                      <th>{{ translatedLang["Score"][selectedLanguage.key] }}</th>
                      <th>{{ translatedLang["Total Frequency"][selectedLanguage.key] }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, index) of sentimentsTable"
                      :data-row-index="index"
                    >
                      <td
                        class="keyword"
                        role="button"
                        tabindex="0"
                        @click="openModal(row.word_new)"
                      >
                        {{ row.word_new.value }}
                      </td>
                      <td class="text-center">
                        <div
                          style="
                            font-family: Heebo;
                            font-size: 16px;
                            font-weight: 400;
                            color: #065559;
                          "
                        >
                          {{ formatNumber(row.positive_frequency) }}
                        </div>
                        <div
                          style="
                            font-family: Heebo;
                            font-size: 16px;
                            font-weight: 400;
                            color: #d90000;
                          "
                        >
                          {{ formatNumber(row.negative_frequency) }}
                        </div>
                      </td>
                      <td class="text-center">
                        <div
                          class="d-flex justify-content-center align-items-center gauge-container"
                        ></div>
                      </td>
                      <td>{{ row.total_frequency }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="noData">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
              </div>
            </div>
          </b-col>
          <b-col cols="4" class="pl-2">
            <div class="section-card my-3">
              <p class="heading">{{ translatedLang["Insights"][selectedLanguage.key] }}</p>
              <div
                style="max-height: 1000px; overflow-y: auto"
                class="thin-scrollerBar pr-1 pt-1"
              >
                <div
                  class="inSightsContainer d-flex"
                  v-for="(insight, index) in viewMostReviewsInsightsData"
                  :key="'most' + index"
                >
                  <div
                    class="col-1 d-flex justify-content-center align-items-center flex-column"
                  >
                    <p
                      class="mb-0 px-2"
                      style="color: #00555a; font-weight: 400"
                    >
                      {{
                        new Date(dateRange.endDate).toLocaleString("en-US", {
                          month: "short",
                        })
                      }}
                    </p>
                    <p
                      class="mb-0 px-2"
                      style="font-size: 20px; font-weight: 600; color: #5e5e5e"
                    >
                      {{ new Date(dateRange.endDate).getDate() }}
                    </p>
                  </div>
                  <div class="col-11 pt-2 pb-2">
                    <p class="insightsContent mb-2" v-html="insight"></p>
                  </div>
                </div>
                <div
                  class="inSightsContainer d-flex mt-3"
                  v-for="(insight, index) in viewWorstReviewsInsightsData"
                  :key="'worst' + index"
                >
                  <div
                    class="col-1 d-flex justify-content-center align-items-center flex-column"
                  >
                    <p
                      class="mb-0 px-2"
                      style="color: #00555a; font-weight: 400"
                    >
                      {{
                        new Date(dateRange.endDate).toLocaleString("en-US", {
                          month: "short",
                        })
                      }}
                    </p>
                    <p
                      class="mb-0 px-2"
                      style="font-size: 20px; font-weight: 600; color: #5e5e5e"
                    >
                      {{ new Date(dateRange.endDate).getDate() }}
                    </p>
                  </div>
                  <div class="col-11 pt-2 pb-2">
                    <p class="insightsContent mb-2" v-html="insight"></p>
                  </div>
                </div>
                <div
                  class="inSightsContainer d-flex mt-3"
                  v-for="(insight, index) in viewKeywordInsightsData"
                  :key="'keyword' + index"
                >
                  <div
                    class="col-1 d-flex justify-content-center align-items-center flex-column"
                  >
                    <p
                      class="mb-0 px-2"
                      style="color: #00555a; font-weight: 400"
                    >
                      {{
                        new Date(dateRange.endDate).toLocaleString("en-US", {
                          month: "short",
                        })
                      }}
                    </p>
                    <p
                      class="mb-0 px-2"
                      style="font-size: 20px; font-weight: 600; color: #5e5e5e"
                    >
                      {{ new Date(dateRange.endDate).getDate() }}
                    </p>
                  </div>
                  <div class="col-11 pt-2 pb-2">
                    <p class="insightsContent mb-2" v-html="insight"></p>
                  </div>
                </div>
                <div v-if="!viewMostReviewsInsightsData.length && !viewWorstReviewsInsightsData.length && !viewKeywordInsightsData.length"
                                    class="noData ml-1 mb-1">
                                    No Data
                                </div>
              </div>
            </div>
          </b-col>
        </b-row> -->
      </div>
      <div v-else-if="compareBrands && !savedViewLoader" class="d-flex">
        <div class="compare-card w-50 ml-2">
          <b-row>
            <b-col>
              <LogoContainer
                :brandName="comparisonList[0].selectedBrand"
                :brandContainer="true"
                :imageHeight="140"
                :imgSrc="comparisonList[0].imgSrc"
              />
            </b-col>
            <b-col
              class="px-2 py-3 d-flex flex-column justify-content-between"
              style="gap: 8px"
            >
              <div style="font-size: 16px">
                <span
                  class="font-weight-bold text-capitalize"
                  style="color: #065559"
                  >{{ comparisonList[0].selectedBrand }}
                </span>
                <div class="mt-2" style="color: #5e5e5e">
                  {{
                    comparisonList[0].selectedBrand === client
                      ? "Primary Brand"
                      : "Competitor Brand"
                  }}
                </div>
              </div>
              <div style="width: 95%">
                <Treeselect
                  v-if="allBrands[selectedPlatform.platform_id].length"
                  v-model="comparisonList[0].selectedBrand"
                  :options="allBrands[selectedPlatform.platform_id]"
                  placeholder="Select Brand"
                  :multiple="false"
                  @input="getCompareBrandsData(0)"
                  :searchable="true"
                >
                  <span slot="noResult"
                    >{{ translatedLang["No elements found"][selectedLanguage.key] }}</span
                  >
                </Treeselect>
              </div>
            </b-col>
          </b-row>
          <div class="mx-2">
            <div class="my-4 d-flex flex-row gap mx-2">
              <button
                type="button"
                v-for="filterState of reviewFilterState"
                :key="filterState"
                class="section-button"
                :class="
                  selectedFilterState === filterState ? 'active-button' : ''
                "
                @click="filterCustomDate(filterState)"
              >
              {{ translatedLang[filterState][selectedLanguage.key] || filterState }}
              </button>
            </div>
            <b-row class="mt-4" :no-gutters="true">
              <b-col cols="6" class="px-2">
                <div
                  class="section-card"
                  v-if="Object.keys(comparisonList[0].ratingsData).length"
                >
                  <ReviewsAndRatings
                    :ratingsData="comparisonList[0].ratingsData"
                  />
                </div>
                <div v-else class="section-card">
                  <p class="heading">{{ translatedLang["Overall Rating"][selectedLanguage.key] }} </p>
                  <noData
                    :loaderVariable="comparisonList[0].isLoading"
                    :message="translatedLang['No Data'][selectedLanguage.key]"
                  />
                </div>
              </b-col>
              <b-col cols="6" class="px-2">
                <div
                  class="section-card"
                  v-if="Object.keys(comparisonList[0].sentimentsCount).length"
                >
                  <Sentiments
                    :sentimentsData="comparisonList[0].sentimentsCount"
                    :navigation="true"
                    @navigate-to-sentiment-details="
                      navigateWordCloud('section-detail' + 0)
                    "
                  />
                </div>
                <div v-else class="section-card">
                  <p class="heading">{{ translatedLang["Customer Sentiments"][selectedLanguage.key] }}</p>
                  <noData
                    :loaderVariable="comparisonList[0].isLoading"
                    :message="translatedLang['No Data'][selectedLanguage.key]"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-4 px-2">
              <b-col cols="12" v-if="comparisonList[0].performanceData.length">
                <PerformanceChart
                  heading="Brand"
                  :performanceData="comparisonList[0].performanceData"
                />
              </b-col>
              <b-col cols="12" v-else>
                <div class="section-card">
                  <p class="heading">{{ translatedLang["Brand Performance"][selectedLanguage.key] }} </p>
                  <noData
                    :loaderVariable="comparisonList[0].isLoading"
                    :message="translatedLang['No Data'][selectedLanguage.key]"
                  />
                </div>
              </b-col>
            </b-row>
            <div class="px-2">
              <div class="py-4" :id="'section-detail' + 0">
                <div
                  class="section-card"
                  v-if="
                    comparisonList[0].wordCloudData.positive &&
                    comparisonList[0].wordCloudData.positive.length
                  "
                >
                  <div
                    class="d-flex justify-content-between align-items-center heading"
                  >
                    <p class="mb-0">{{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                    <div class="customSelect">
                      <select
                        class="form-control text-capitalize platform-select"
                        v-model="comparisonList[0].selectedPositiveCloudLimit"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </div>
                  <WordCloud
                    :cloudData="
                      comparisonList[0].wordCloudData.positive.slice(
                        0,
                        comparisonList[0].selectedPositiveCloudLimit
                      )
                    "
                    :comparisonIndex="0"
                    color="#065559"
                    @analyse-keyword="openCompPositiveModal"
                  />
                </div>
                <div v-else class="section-card">
                  <p class="heading">{{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                  <noData
                    :loaderVariable="comparisonList[0].isLoading"
                    :message="translatedLang['No Data'][selectedLanguage.key]"
                  />
                </div>
              </div>
              <div>
                <div
                  class="section-card"
                  v-if="
                    comparisonList[0].wordCloudData.negative &&
                    comparisonList[0].wordCloudData.negative.length
                  "
                >
                  <div
                    class="d-flex justify-content-between align-items-center heading"
                  >
                    <p class="mb-0">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                    <div class="customSelect">
                      <select
                        class="form-control text-capitalize platform-select"
                        v-model="comparisonList[0].selectedNegativeCloudLimit"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </div>
                  <WordCloud
                    :cloudData="
                      comparisonList[0].wordCloudData.negative.slice(
                        0,
                        comparisonList[0].selectedNegativeCloudLimit
                      )
                    "
                    :comparisonIndex="0"
                    color="#FD5542"
                    @analyse-keyword="openCompNegativeModal"
                  />
                </div>
                <div v-else class="section-card">
                  <p class="heading">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                  <noData
                    :loaderVariable="comparisonList[0].isLoading"
                    :message="translatedLang['No Data'][selectedLanguage.key]"
                  />
                </div>
              </div>
              <div class="section-card my-4">
                <p class="heading">{{ translatedLang["All Sentiments"][selectedLanguage.key] }}</p>
                <div class="thin-scroller">
                  <table
                    class="mt-4 w-100"
                    id="sentiment-comp-table-0"
                    v-if="comparisonList[0].sentimentsTable.length"
                  >
                    <thead>
                      <tr>
                        <th>{{ translatedLang["Keyword"][selectedLanguage.key] }}</th>
                      <th>{{ translatedLang["Frequency"][selectedLanguage.key] }}</th>
                      <th>{{ translatedLang["Score"][selectedLanguage.key] }}</th>
                      <th>{{ translatedLang["Total Frequency"][selectedLanguage.key] }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row of comparisonList[0].sentimentsTable">
                        <td
                          class="keyword"
                          role="button"
                          tabindex="0"
                          @click="openModal(row.word_new, 0)"
                        >
                          {{ row.word_new.value }}
                        </td>
                        <td class="text-center">
                          <div
                            style="
                              font-family: Heebo;
                              font-size: 16px;
                              font-weight: 400;
                              color: #065559;
                            "
                          >
                            {{ formatNumber(row.positive_frequency) }}
                          </div>
                          <div
                            style="
                              font-family: Heebo;
                              font-size: 16px;
                              font-weight: 400;
                              color: #d90000;
                            "
                          >
                            {{ formatNumber(row.negative_frequency) }}
                          </div>
                        </td>
                        <td class="text-center">
                          <div
                            class="d-flex justify-content-center align-items-center gauge-container"
                          >
                            <!-- <GaugeChart :rawData="row" /> -->
                          </div>
                        </td>
                        <td>
                          {{ row.positive_frequency + row.negative_frequency }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else>
                    <noData
                      :loaderVariable="comparisonList[0].isLoading"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="w-50 thin-scroller"
          style="display: flex; overflow-x: scroll"
          id="scroll-container"
        >
          <div
            class="compare-card mx-1"
            :id="'compare-card-' + idx"
            style="min-width: 90%"
            v-if="comparisonList[idx]"
            v-for="idx in 5"
          >
            <b-row>
              <b-col>
                <LogoContainer
                  :brandName="comparisonList[idx].selectedBrand"
                  :brandContainer="true"
                  :imageHeight="140"
                  :imgSrc="comparisonList[idx].imgSrc"
                />
              </b-col>
              <b-col
                class="px-2 py-3 d-flex flex-column justify-content-between position-relative"
                style="gap: 8px"
              >
                <div style="font-size: 16px">
                  <span
                    class="font-weight-bold text-capitalize"
                    style="color: #065559"
                    >{{ comparisonList[idx].selectedBrand }}
                  </span>
                  <div class="mt-2" style="color: #5e5e5e">
                    {{
                      comparisonList[idx].selectedBrand === client
                        ? "Primary Brand"
                        : "Competitor Brand"
                    }}
                  </div>
                </div>
                <div style="width: 95%">
                  <Treeselect
                    v-if="allBrands[selectedPlatform.platform_id].length"
                    v-model="comparisonList[idx].selectedBrand"
                    :options="allBrands[selectedPlatform.platform_id]"
                    placeholder="Select Brand"
                    :multiple="false"
                    @input="getCompareBrandsData(idx)"
                    :searchable="true"
                  >
                    <span slot="noResult"
                      >{{ translatedLang["No elements found"][selectedLanguage.key] }}.</span
                    >
                  </Treeselect>
                </div>
                <div class="close-card" @click="removeCompareCard(idx)">
                  <i class="fa fa-close"></i>
                </div>
              </b-col>
            </b-row>
            <div class="mx-2">
              <div class="my-4 d-flex flex-row gap mx-2">
                <!-- Button Groups for date filtering -->
                <button
                  type="button"
                  v-for="filterState of reviewFilterState"
                  :key="filterState"
                  class="section-button"
                  :class="
                    selectedFilterState === filterState ? 'active-button' : ''
                  "
                  @click="filterCustomDate(filterState)"
                >
                {{ translatedLang[filterState][selectedLanguage.key] || filterState }}
                </button>
              </div>
              <b-row class="mt-4" :no-gutters="true">
                <b-col cols="6" class="px-2">
                <div
                  class="section-card"
                  v-if="Object.keys(comparisonList[idx].ratingsData).length"
                >
                  <ReviewsAndRatings
                    :ratingsData="comparisonList[idx].ratingsData"
                  />
                </div>
                <div v-else class="section-card">
                  <p class="heading">{{ translatedLang["Overall Rating"][selectedLanguage.key] }}</p>
                  <noData
                    :loaderVariable="comparisonList[idx].isLoading"
                    :message="translatedLang['No Data'][selectedLanguage.key]"
                  />
                </div>
              </b-col>
                <b-col cols="6" class="px-2">
                  <div
                    class="section-card"
                    v-if="
                      Object.keys(comparisonList[idx].sentimentsCount).length
                    "
                  >
                    <Sentiments
                      :sentimentsData="comparisonList[idx].sentimentsCount"
                      :navigation="true"
                    @navigate-to-sentiment-details="
                        navigateWordCloud('section-detail' + idx)
                      "
                    />
                  </div>
                  <div v-else class="section-card">
                    <p class="heading">{{ translatedLang["Customer Sentiments"][selectedLanguage.key] }}</p>
                    <noData
                      :loaderVariable="comparisonList[idx].isLoading"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-4 px-2">
                <b-col
                  cols="12"
                  v-if="comparisonList[idx].performanceData.length"
                >
                  <PerformanceChart
                    heading="Brand"
                    :performanceData="comparisonList[idx].performanceData"
                  />
                </b-col>
                <b-col cols="12" v-else>
                  <div class="section-card">
                    <p class="heading">{{ translatedLang["Brand Performance"][selectedLanguage.key] }}</p>
                    <noData
                      :loaderVariable="comparisonList[idx].isLoading"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </b-col>
              </b-row>
              <div class="px-2">
                <div class="py-4" :id="'section-detail' + idx">
                  <div
                    class="section-card"
                    v-if="
                      comparisonList[idx].wordCloudData.positive &&
                      comparisonList[idx].wordCloudData.positive.length
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center heading"
                    >
                      <p class="mb-0">{{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                      <div class="customSelect">
                        <select
                          class="form-control text-capitalize platform-select"
                          v-model="
                            comparisonList[idx].selectedPositiveCloudLimit
                          "
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                    <WordCloud
                      :cloudData="
                        comparisonList[idx].wordCloudData.positive.slice(
                          0,
                          comparisonList[idx].selectedPositiveCloudLimit
                        )
                      "
                      color="#065559"
                      :comparisonIndex="idx"
                      @analyse-keyword="openCompPositiveModal"
                    />
                  </div>
                  <div v-else class="section-card">
                    <p class="heading">{{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                    <noData
                      :loaderVariable="comparisonList[idx].isLoading"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </div>
                <div>
                  <div
                    class="section-card"
                    v-if="
                      comparisonList[idx].wordCloudData.negative &&
                      comparisonList[idx].wordCloudData.negative.length
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center heading"
                    >
                      <p class="mb-0">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                      <div class="customSelect">
                        <select
                          class="form-control text-capitalize platform-select"
                          v-model="
                            comparisonList[idx].selectedNegativeCloudLimit
                          "
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                    <WordCloud
                      :cloudData="
                        comparisonList[idx].wordCloudData.negative.slice(
                          0,
                          comparisonList[idx].selectedNegativeCloudLimit
                        )
                      "
                      color="#FD5542"
                      :comparisonIndex="idx"
                      @analyse-keyword="openCompNegativeModal"
                    />
                  </div>
                  <div v-else class="section-card">
                    <p class="heading">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                    <noData
                      :loaderVariable="comparisonList[idx].isLoading"
                      :message="translatedLang['No Data'][selectedLanguage.key]"
                    />
                  </div>
                </div>
                <div class="section-card my-4">
                  <p class="heading">{{ translatedLang["All Sentiments"][selectedLanguage.key] }}</p>
                  <div class="thin-scroller">
                    <table
                      class="mt-4 w-100"
                      :id="'sentiment-comp-table-' + idx"
                      v-if="comparisonList[idx].sentimentsTable.length"
                    >
                      <thead>
                        <tr>
                            <th>{{ translatedLang["Keyword"][selectedLanguage.key] }}</th>
                            <th>{{ translatedLang["Frequency"][selectedLanguage.key] }}</th>
                            <th>{{ translatedLang["Score"][selectedLanguage.key] }}</th>
                            <th>{{ translatedLang["Total Frequency"][selectedLanguage.key] }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row of comparisonList[idx].sentimentsTable">
                          <td
                            class="keyword"
                            role="button"
                            tabindex="0"
                            @click="openModal(row.word_new, idx)"
                          >
                            {{ row.word_new.value }}
                          </td>
                          <td class="text-center">
                            <div
                              style="
                                font-family: Heebo;
                                font-size: 16px;
                                font-weight: 400;
                                color: #065559;
                              "
                            >
                              {{ formatNumber(row.positive_frequency) }}
                            </div>
                            <div
                              style="
                                font-family: Heebo;
                                font-size: 16px;
                                font-weight: 400;
                                color: #d90000;
                              "
                            >
                              {{ formatNumber(row.negative_frequency) }}
                            </div>
                          </td>
                          <td class="text-center">
                            <div
                              class="d-flex justify-content-center align-items-center gauge-container"
                            ></div>
                          </td>
                          <td>
                            {{
                              row.positive_frequency + row.negative_frequency
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <noData
                        :loaderVariable="comparisonList[idx].isLoading"
                        :message="translatedLang['No Data'][selectedLanguage.key]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="showArrow"
            class="scroll-arrow-container"
            @click="scrollToAddProduct"
          >
            <div class="scroll-arrow">
              <i class="fa fa-arrow-right"></i>
            </div>
          </div>
          <div
            v-if="comparisonList.length < 5 && !showArrow"
            :style="
              comparisonList.length === 1 ? 'min-width: 100%' : 'min-width: 90%'
            "
          >
            <div class="add-comparison">
              <div class="plus-icon" @click="prepareComparisonList()">+</div>
              <div style="font-size: 16px; font-weight: 500">{{ translatedLang["Add Product"][selectedLanguage.key] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="keywordModal"
      size="xl"
      :title="modalTitle"
      @hidden="resetModal"
    > 
      <div class="modal-control-panel mt-3">
        <ul>
          <li
            v-for="tab of modalTabs"
            :key="tab"
            @click="selectedModalTab = tab"
            :class="{ 'selected-tab': tab === selectedModalTab }"
          >
            {{ translatedLang[tab][selectedLanguage.key] || tab }}
          </li>
        </ul>
        <div class="d-flex" style="margin-top: -16px">
          <b-button-toolbar
            aria-label="Toolbar with buttons group"
            v-show="
              selectedModalTab === 'Frequency' ||
              selectedModalTab === 'Score' ||
              selectedModalTab === 'Review Count'
            "
          >
            <b-form-radio-group
              class="mr-3 radiohide"
              id="radiosBtn"
              buttons
              button-variant="outline-secondary"
              @change="updateSentimentData"
              v-model="keywordInterval"
              name="radiosBtn"
            >
              <b-form-radio class="mx-0" value="month">{{ translatedLang["Month"][selectedLanguage.key] }}</b-form-radio>
              <b-form-radio class="mx-0" value="week">{{ translatedLang["Week"][selectedLanguage.key] }}</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <date-range-picker
            v-model="modalDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDate"
            :max-date="maxDate"
            :ranges="false"
            @update="updateModal"
          >
          </date-range-picker>
        </div>
      </div>
      <div v-if="Object.keys(keywordWiseSentiments).length">
        <KeywordModalCard
          :selectedTab="selectedModalTab"
          :keywordReview="keywordWiseReviews"
          :keywordSentiment="keywordWiseSentiments"
          :keywordTreeData="keywordTreeData"
          @filter-reviews="filterReviews"
          @toggle-node="toggleTreeNode"
        />
      </div>
    </b-modal>
    <b-modal
      size="md"
      class="customModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showViewModal"
      :title="viewModalName"
    >
      <div class="customMultiselect" v-if="viewModalName === 'Save View'">
        <multiselect
          v-model="selectedModalView"
          :options="modalViewOptions"
          :multiple="false"
          :searchable="false"
          placeholder="Select View"
          label="view_name"
          track-by="view_id"
          :showLabels="false"
          :close-on-select="true"
          :allow-empty="false"
        >
        </multiselect>
      </div>
      <input
        required
        type="text"
        v-model="newViewName"
        class="text-capitalize customInput px-2"
        v-show="
          viewModalName === 'Edit View' ||
          (viewModalName === 'Save View' &&
            selectedModalView.view_id === 'add_new')
        "
      />
      <div class="d-flex justify-content-end align-items-center mt-3">
        <button
          class="btn navigation-btn"
          :disabled="spinLoader"
          @click="saveCompareView"
        >
          <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
          <span>{{ translatedLang["Save View"][selectedLanguage.key] }}</span>
        </button>
      </div>
    </b-modal>
    <b-modal
      title="Delete View"
      v-model="showDeleteModal"
      class="container-modal-ASIN"
    >
      <div class="modal-delete-content d-flex align-items-start mb-2">
        <div class="delete-alert text-center rounded-circle px-2 mr-3">
          &#9888;
        </div>
        <div>
            {{ translatedLang["delete this View"][selectedLanguage.key] }}.<br />{{ translatedLang["Are you sure"][selectedLanguage.key] }}
          ?
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <b-button @click="showDeleteModal = false" class="btn primarycolor"
          >{{ translatedLang["No"][selectedLanguage.key] }}, {{ translatedLang["Keep It"][selectedLanguage.key] }}.</b-button
        >
        <button
          @click="deleteView"
          :disabled="spinLoader"
          class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-viewBtn"
          style="background-color: var(--red)"
        >
          <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
          <span>{{ translatedLang["Yes"][selectedLanguage.key] }}, {{ translatedLang["Delete"][selectedLanguage.key] }}!</span>
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import Loader from "../Components/Loader.vue";
import LogoContainer from "./Components/LogoContainer.vue";
import BrandIndicator from "./Components/BrandIndicator.vue";
import ReviewsAndRatings from "./Components/ReviewsAndRatings.vue";
import Sentiments from "./Components/Sentiments.vue";
import PerformanceChart from "./Components/PerformanceChart.vue";
import LatestReviews from "./Components/LatestReviews.vue";
import WordCloud from "../commonCharts/WordCloud.vue";
import GaugeChart from "../commonCharts/GaugeChart.vue";
import KeywordModalCard from "./Components/KeywordModalCard.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Multiselect from "vue-multiselect";
import IconStar from "../../assets/IconStar.vue";
import noData from "../Components/noData.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "BrandReviews",
  components: {
    Multiselect,
    Treeselect,
    Loader,
    LogoContainer,
    BrandIndicator,
    ReviewsAndRatings,
    Sentiments,
    PerformanceChart,
    LatestReviews,
    WordCloud,
    GaugeChart,
    KeywordModalCard,
    IconStar,
    noData,
  },
  data() {
    return {
      reviewsLoader: false,
      prodcutReviewAPILoading: false,
      sentimentsLoader: false,
      modalLoader: false,
      savedViewLoader: false,
      imageLoader: false,
      spinLoader: false,
      dateRange: {
        startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      modalDateRange: {
        startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(3, "years")),
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Reviews_And_Ratings,
      platforms: [],
      selectedPlatform: "",
      reviewFilterState: ["Overview", "Last Week", "Last Month", "Last Year"],
      selectedFilterState: "Overview",
      performanceData: [],
      performanceRatingsData: [],
      ratingsData: {},
      reviewsData: [],
      wordCloudData: {},
      sentimentsCount: {},
      sentimentsTable: [],
      selectedPositiveCloudLimit: 10,
      selectedNegativeCloudLimit: 10,
      keywordModal: false,
      selectedModalKeyword: "",
      modalTitle: "",
      modalIndex: null,
      keywordWiseReviews: [],
      keywordWiseSentiments: {},
      keywordTreeData: {},
      modalTabs: [
        "Reviews",
        "Frequency",
        // "Score",
        "Review Count",
        // "Tree Structure",
        "Contribution tree",
      ],
      selectedModalTab: "Reviews",
      keywordInterval: "month",
      compareBrands: false,
      allBrands: {},
      selectedGlobalBrand: {},
      comparisonList: [],
      showArrow: false,
      brandImage: "",
      savedViews: [],
      viewOptions: [],
      selectedView: "",
      showViewModal: false,
      viewModalName: "",
      showDeleteModal: false,
      newViewName: "",
      selectedModalView: {
        view_id: "add_new",
        view_name: "Add New",
      },
      modalViewOptions: [],
      aiReviewSummary: "",
      marketShare: {},
      //InsightsData
      viewKeywordInsightsData: "",
      viewMostReviewsInsightsData: "",
      viewWorstReviewsInsightsData: "",
      brandNameFromLogin: JSON.parse(localStorage.reviewUserData).data
        .brand_name[0],
      sentimentsLoader1: true,
      loaderUpdated: false,
      showNoDataImgForUser: false,
    };
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  mounted() {
    this.getLastUpdatedDates();
    this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    getLastUpdatedDates() {
      this.loaderUpdated = true;
      this.prodcutReviewAPILoading = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          if (response.body.data.reviews_and_ratings) {
            this.showNoDataImgForUser = false;
            this.dateRange.endDate = moment(
              response.body.data.reviews_and_ratings?.end_date
            ).format("YYYY-MM-DD");

            this.dateRange.startDate = moment(
                response.body.data.reviews_and_ratings?.end_date
            ).subtract(1,'month').format("YYYY-MM-DD");
            this.maxDate= response.body.data.reviews_and_ratings?.end_date
            this.minDate= response.body.data.reviews_and_ratings?.start_date
            this.getPlatformsAndCategories();
            this.loaderUpdated = false;
          } else {
            this.showNoDataImgForUser = true;
            this.loaderUpdated = false;
          }
        })
        .catch((err) => {
          this.loaderUpdated = false;
          console.log("err", err);
        })
        .finally(() => {
          this.loaderUpdated = false;
        });
    },
    resetComparisonList() {
      this.selectedGlobalBrand = this.allBrands[
        this.selectedPlatform.platform_id
      ].find((brand) => {
        if (this.client === "lyxel_labs") {
          return brand.id === "godrej";
        }
        return brand.id === this.brandNameFromLogin;
      });

      if (this.compareBrands) {
        for (let index in this.comparisonList) {
          if ($.fn.DataTable.isDataTable(`#sentiment-comp-table-${index}`)) {
            $(`#sentiment-comp-table-${index}`).DataTable().clear().destroy();
          }
          // $(`#sentiment-comp-table-${index}`).DataTable().destroy();
        }

        this.comparisonList = [];
        this.prepareComparisonList(this.brandNameFromLogin);
      }
    },
    refresh() {
      this.modalDateRange = this.dateRange;
      if (!this.compareBrands) {
        this.getBrandImage(this.selectedGlobalBrand.id, null);
        this.getBrandReviews();
        this.getBrandSentiments();
        this.getInsightsData();
        this.getPerformanceRating();
      } else {
        this.resetComparisonList();
      }
    },

    getInsightsData() {
      this.getKeywordInsightsData();
      this.getMostReviewsInsightsData();
      this.getWorstReviewsInsightsData();
    },

    activateComparison() {
      this.compareBrands = true;
      this.getSavedViews();
      this.prepareComparisonList(this.brandNameFromLogin);

      // this.$nextTick(() => {
      //     this.getCompareBrandsData(0);
      // })
    },
    deactivateComparison() {
      this.compareBrands = false;
      this.comparisonList = [];
      this.savedViews = [];
      this.viewOptions = [];
      this.refresh();
    },
    removeCompareCard(index) {
      this.comparisonList.splice(index, 1);
      if (this.comparisonList.length < 2) {
        this.showArrow = false;
      } else this.showArrow = true;
    },
    scrollToAddProduct() {
      this.showArrow = false;

      this.$nextTick(() => {
        const compareCard = document.querySelector(".add-comparison");
        compareCard.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest",
        });

        const main = document.getElementsByTagName("main");
        main.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });
    },
    prepareComparisonList(selectedBrand = null, shouldFetch = true) {
      this.comparisonList.push({
        selectedBrand: selectedBrand,
        imgSrc: "",
        isLoading: true,
        performanceData: [],
        ratingsData: {},
        wordCloudData: {},
        sentimentsCount: {},
        sentimentsTable: [],
        selectedPositiveCloudLimit: 10,
        selectedNegativeCloudLimit: 10,
      });

      this.$nextTick(() => {
        if (this.comparisonList.length > 1 && this.comparisonList.length < 5) {
          this.showArrow = true;
          document
            .getElementById(`compare-card-${this.comparisonList.length - 1}`)
            .scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "start",
            });

          const main = document.getElementsByTagName("main");
          main.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      });
      if (shouldFetch) {
        this.getCompareBrandsData(this.comparisonList.length - 1);
      }
    },
    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    navigateWordCloud(id) {
      document
        .getElementById(id)
        .scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
    },
    filterCustomDate(filter) {
      switch (filter) {
        case "Overview":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment().startOf("year").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          };
          this.refresh();
          break;
        case "Last Week":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment()
              .subtract(1, "week")
              .startOf("week")
              .format("YYYY-MM-DD"),
            endDate: moment()
              .subtract(1, "week")
              .endOf("week")
              .format("YYYY-MM-DD"),
          };
          this.refresh();
          break;
        case "Last Month":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment()
              .subtract(1, "month")
              .startOf("month")
              .format("YYYY-MM-DD"),
            endDate: moment()
              .subtract(1, "month")
              .endOf("month")
              .format("YYYY-MM-DD"),
          };
          this.refresh();
          break;
        case "Last Year":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment()
              .subtract(1, "year")
              .startOf("year")
              .format("YYYY-MM-DD"),
            endDate: moment()
              .subtract(1, "year")
              .endOf("year")
              .format("YYYY-MM-DD"),
          };
          this.refresh();
          break;
        default:
          break;
      }
    },
    openCompNegativeModal(keyword, catName, compIndex) {
      this.openModal(keyword, compIndex, "negative");
    },
    openCompPositiveModal(keyword, catName, compIndex) {
      this.openModal(keyword, compIndex, "positive");
    },
    openNegativeModal(keyword) {
      this.openModal(keyword, null, "negative");
    },
    openPositiveModal(keyword) {
      this.openModal(keyword, null, "positive");
    },
    toggleTreeNode(nodeName) {
      this.keywordTreeData.children.forEach((child) => {
        if (child.name == nodeName) {
          child.showChildren = !child.showChildren;
        } else {
          child.showChildren = false;
        }
      });
    },
    openModal(targetKeyword, modalIndex = null, sentType = "") {
      if(targetKeyword.key){
        this.selectedModalKeyword = targetKeyword.key;
      }
      else{
        this.selectedModalKeyword = targetKeyword;
      }
      this.modalTitle = this.selectedModalKeyword
      this.modalIndex = modalIndex;
      this.getKeywordReviews(sentType);
      this.getKeywordSentiment();
      this.keywordModal = true;
    },
    resetModal() {
      this.selectedModalKeyword = "";
      this.modalTitle = "";
      this.keywordWiseReviews = [];
      this.keywordWiseSentiments = {};
      this.keywordTreeData = {};
      this.selectedModalTab = "Reviews";
      (this.keywordInterval = "month"), (this.modalIndex = null);
    },
    updateModal() {
      this.getKeywordReviews();
      this.getKeywordSentiment();
    },
    filterReviews(sentimentType) {
      this.getKeywordReviews(sentimentType);
    },
    updateSentimentData() {
      this.$nextTick(() => {
        this.getKeywordSentiment();
      });
    },

    getKeywordInsightsData() {
      const url = "/api/v2/new/keyword";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [this.selectedGlobalBrand.id],
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewKeywordInsightsData = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in keyword insights`, err);
        });
    },

    getMostReviewsInsightsData() {
      const url = "/api/v2/most/reviews";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),

        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [this.selectedGlobalBrand.id],
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewMostReviewsInsightsData = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in  most reviews insights`, err);
        });
    },

    getWorstReviewsInsightsData() {
      const url = "/api/v2/worst/reviews";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [this.selectedGlobalBrand.id],
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewWorstReviewsInsightsData = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in  worst reviews insights`, err);
        });
    },

    getKeywordReviews(sentimentType) {
    this.modalLoader = true;
      const brandName =
        this.modalIndex !== null
          ? this.comparisonList[this.modalIndex].selectedBrand
          : this.brandNameFromLogin;

      const url = "/api/v2/indian_clients/keyword_reviews_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword,
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        brand_name: [brandName],
        category_name: [],
        product_name: [],
        limit: 50,
        offset: 0,
        sentiment_type: sentimentType || "positive",
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.keywordWiseReviews = [];
      this.keywordTreeData = {};
      

      this.$http
        .post(url, payload)
        .then((res) => {
          this.modalLoader = false;
          this.keywordWiseReviews = res.body.data;
          this.keywordTreeData = res.body.percent;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in fetching keyword reviews`, err);
        });
    },
    getKeywordSentiment() {
      const brandName =
        this.modalIndex !== null
          ? this.comparisonList[this.modalIndex].selectedBrand
          : this.brandNameFromLogin;

      const url = "/api/v2/indian_clients/keyword_sentiments_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword,
        interval: this.keywordInterval,
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        brand_name: [brandName],
        category_name: [],
        product_name: [],
      };

      this.keywordWiseSentiments = {};
      this.modalLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.modalLoader = false;
          this.keywordWiseSentiments = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in fetching keyword sentiments`, err);
        });
    },
    getAllBrands() {
      const url = "/api/v2/indian_clients/product_brand";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        label: "brand",
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.allBrands = null;
      this.reviewsLoader = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          this.allBrands = res.body.data;
          this.reviewsLoader = false;

          this.selectedGlobalBrand = this.allBrands[
            this.selectedPlatform.platform_id
          ].find((brand) => {
            if (this.client === "lyxel_labs") {
              return brand.id === "godrej";
            }
            return brand.id === this.brandNameFromLogin;
          });

          this.$nextTick(() => this.refresh());
        })
        .catch((err) => {
          console.log("Error in getting all brands", err);
          this.reviewsLoader = false;
        });
    },
    getBrandImage(brandName, brandIndex = null) {
      if (this.compareBrands) {
        this.comparisonList[
          brandIndex
        ].imgSrc = `https://sense-images.sgp1.cdn.digitaloceanspaces.com/lyxelBrands/${brandName}.png`;
      } else {
        this.brandImage = `https://sense-images.sgp1.cdn.digitaloceanspaces.com/lyxelBrands/${brandName}.png`;
      }
    },
    getCompareBrandsData(index) {
      this.reviewsLoader = true;
      this.comparisonList[index].isLoading = true;
      if ($.fn.DataTable.isDataTable(`#sentiment-comp-table-${index}`)) {
        $(`#sentiment-comp-table-${index}`).DataTable().clear().destroy();
      }

      const brandName = this.comparisonList[index].selectedBrand;

      this.getBrandImage(brandName, index);

      // Reset variables
      this.comparisonList[index].performanceData = [];
      this.comparisonList[index].ratingsData = {};
      this.comparisonList[index].wordCloudData = {};
      this.comparisonList[index].sentimentsCount = {};
      this.comparisonList[index].sentimentsTable = [];

      const url = "/api/v2/indian_clients/compare_data";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        compare: [
          {
            brand_name: brandName,
          },
        ],
        compare_type: "brand",
        // positive_limit: Number(this.comparisonList[index].selectedPositiveCloudLimit),
        // negative_limit: Number(this.comparisonList[index].selectedNegativeCloudLimit)
        positive_limit: 50,
        negative_limit: 50,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.reviewsLoader = false;
          this.comparisonList[index].isLoading = false;
          this.comparisonList[index].performanceData =
            res.body.data[brandName].reviews.performance_ratings;
          this.comparisonList[index].ratingsData =
            res.body.data[brandName].reviews.ratings;
          this.comparisonList[index].wordCloudData =
            res.body.data[brandName].sentiment.word_clowd;
          this.comparisonList[index].sentimentsCount =
            res.body.data[brandName].sentiment.sentiment;
          this.comparisonList[index].sentimentsTable =
            res.body.data[brandName].sentiment.table;

          this.$nextTick(() => {
            this.processTable(`#sentiment-comp-table-${index}`);
          });
        })
        .catch((err) => {
          this.reviewsLoader = false;
          this.comparisonList[index].isLoading = false;
          console.log("Error in getting compare brand data", err);
        });
    },
    getPlatformsAndCategories() {
      const url = "/api/v2/india_clients/product_platform_details";
      const payload = {
        client: this.client,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.reviewsLoader = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          this.reviewsLoader = false;
          this.platforms = res.body.data.platform;
          this.selectedPlatform = this.platforms[0];

          this.$nextTick(() => this.getAllBrands());
        })
        .catch((err) => {
          this.reviewsLoader = false;
          console.log("Error in fetching platforms and categories", err);
        });
    },

    updateSelectedLabels(value) {
      return value.platform_name.replaceAll("_", " ");
    },
    // getAllBrandByPlatform(){
    //     return this.allBrands[this.selectedPlatform.platform_name];
    // },
    changePlatformForBrandSelection() {
      // this.selectedGlobalBrand = this.allBrands[this.selectedPlatform.platform_name][0];
    },
    getBrandReviews() {
      this.performanceData = [];
      this.ratingsData = {};
      this.reviewsData = [];
      this.aiReviewSummary = "";
      
      const url = "/api/v2/indian_clients/product_reviews";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        brand: [this.selectedGlobalBrand.id],
        language: this.$store.state.DemoStore.selectedLanguage.key, 
      };
      this.prodcutReviewAPILoading = true;
      this.reviewsLoader = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          this.reviewsLoader = false;
          if (Object.keys(res.body.data[this.selectedGlobalBrand.id]).length) {
            this.performanceData =
              res.body.data[this.selectedGlobalBrand.id].performance_ratings;
            this.ratingsData =
              res.body.data[this.selectedGlobalBrand.id].ratings;
            this.reviewsData =
              res.body.data[this.selectedGlobalBrand.id].reviews;
            this.aiReviewSummary =
              res.body.data[this.selectedGlobalBrand.id].summary;
            this.marketShare = res.body.data.market_share;
          }
          this.prodcutReviewAPILoading = false;
        })
        .catch((err) => {
          this.reviewsLoader = false;
          this.prodcutReviewAPILoading = false;
          console.log("Error in fetching reviews", err);
        });
    },
    getPerformanceRating() {
      const url = "/api/v2/reviews/starcount";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [this.selectedGlobalBrand.id],
        language: this.$store.state.DemoStore.selectedLanguage.key,
        category: [],
        product: [],
        interval: "month",
      };

      this.performanceRatingsData = [];
      this.sentimentsLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.performanceRatingsData = res.body.data;
          this.sentimentsLoader = false;
        })
        .catch((err) => {
          console.error(`Error in getting performance data::${err}`);
          this.sentimentsLoader = false;
        });
    },
    getBrandSentiments() {
      if ($.fn.DataTable.isDataTable("#sentiments-table")) {
        $("#sentiments-table").DataTable().clear().destroy();
      }
      this.wordCloudData = {};
      this.sentimentsCount = {};
      this.sentimentsTable = [];

      const url = "/api/v2/indian_clients/sentiments_data";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        brand: [this.selectedGlobalBrand.id],
        positive_limit: 50,
        negative_limit: 50,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.sentimentsLoader1 = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          this.sentimentsLoader1 = false;
          if (Object.keys(res.data.data).length) {
            this.sentimentsCount = res.data.data.sentiment;
            this.wordCloudData = res.data.data.word_clowd;
            this.sentimentsTable = res.data.data.table;

            this.$nextTick(() => {
              this.processTable("#sentiments-table");
            });
          }
        })
        .catch((err) => {
          this.sentimentsLoader1 = false;
          console.log("Error in getting sentiments data", err);
        });
    },
    processTable(id) {
      if ($.fn.DataTable.isDataTable(id)) {
        $(id).DataTable().clear().destroy();
      }
      const tableInstance = $(id).DataTable({
        initComplete: function (settings, json) {
          $(".dataTables_scrollBody tfoot tr").css({ visibility: "collapse" });
          $(".dataTables_scrollBody thead tr").css({ visibility: "collapse" });
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        columnDefs: [
          { orderData: 3, targets: 1 },
          { visible: false, targets: 3 },
          { orderable: false, targets: 2 },
        ],
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
          searchPlaceholder: "Search...",
        },

        pagingType: "full_numbers",
        searching: true,
        sorting: [[1, "desc"]],
        autoWidth: false,
      });

      tableInstance.on("draw.dt", () =>
        this.renderVisibleCharts(tableInstance)
      );

      this.$nextTick(() => this.renderVisibleCharts(tableInstance));

      let search = require("../../../public/Icons_SVG/Search.svg");
      $(id + "_filter > label").append(`<div><img src='${search}' /></div>`);
    },
    renderVisibleCharts(instance) {
      const tableID = instance.table().node().id;
      $(`#${tableID} .gauge-container`).empty();

      const extractedIndex = tableID.match(/\d+/g);
      const tableIndex = extractedIndex !== null ? extractedIndex[0] : null;
      const dataContainer =
        tableIndex === null
          ? this.sentimentsTable
          : this.comparisonList[tableIndex].sentimentsTable;

      const keywords = instance
        .column(0, { order: "current", page: "current" })
        .data()
        .toArray()
        // .toArray().map(item => item.split(":")[0].trim());;
      const gaugeContainers = document.querySelectorAll(
        `#${tableID} .gauge-container`
      );
      // console.log(keywords, 'store')
      keywords.forEach((keyword, index) => {
        const container = gaugeContainers[index];

        if (container) {
          const chartData = dataContainer.find((row) => row.word_new.value === keyword);

          const ChartConstructor = Vue.extend(
            this.$options.components.GaugeChart
          );
          const chartInstance = new ChartConstructor({
            propsData: { rawData: chartData },
          });

          chartInstance.$mount();
          container.appendChild(chartInstance.$el);
        }
      });
    },
    resetViewModal() {
      this.viewModalName = "";
      this.newViewName = "";
      this.modalViewOptions = [];
      this.showViewModal = false;
    },
    openViewModal(viewType) {
      this.modalViewOptions = [
        ...this.viewOptions,
        {
          view_id: "add_new",
          view_name: "Add New",
        },
      ];

      if (viewType === "Edit View") {
        this.newViewName = this.selectedView.view_name;
      } else if (viewType === "Save View") {
        this.selectedModalView = {
          view_id: "add_new",
          view_name: "Add New",
        };

        this.newViewName = "";
      }

      this.$nextTick(() => {
        this.viewModalName = viewType;
        this.showViewModal = true;
      });
    },
    getSavedViews() {
      this.savedViews = [];
      this.viewOptions = [];
      const url =
        "/api/v2/reviews/comparison_view?view_for=brand_reviews_compare";

      this.$http
        .get(url)
        .then((res) => {
          this.savedViews = res.data.data;
          if (this.savedViews.length) {
            this.savedViews.map((view) => {
              this.viewOptions.push({
                view_id: view.view_id,
                view_name: view.view_name,
              });
            });
          }

          if (
            this.viewModalName === "Edit View" ||
            (this.viewModalName === "Save View" &&
              this.selectedModalView.view_id === "add_new")
          ) {
            this.selectedView = this.viewOptions.find(
              (view) => view.view_name === this.newViewName
            );
            this.resetViewModal();
          } else this.resetViewModal();
        })
        .catch((err) => {
           this.$bvToast.toast(err.body.msg, {
              title: "Save Error",
              variant: "danger",
              solid: true,
              toaster: "b-toaster-top-right",
              autoHideDelay: 3000,
              appendToast: true,
          });
          console.log(`Error getting saved views:: ${err}`);
        });
    },
    saveCompareView() {
      if (this.viewModalName === "Edit View" && !this.newViewName) {
        this.$bvToast.toast("Please provide a name to edit this view", {
          title: "Edit View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      } else if (
        this.selectedModalView.view_id === "add_new" &&
        !this.newViewName
      ) {
        this.$bvToast.toast("Please provide a name to save new view", {
          title: "Save View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }

      this.spinLoader = true;

      if (this.newViewName) {
        let capitalizedText;
        capitalizedText = this.newViewName
          .split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");

        this.newViewName = capitalizedText;
      }

      const url = "/api/v2/reviews/comparison_view";
      let payload = {
        view_for: "brand_reviews_compare",
        view_data: {
          page_filter: {
            dateRange: {
              startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
              endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
            },
            selectedPlatform: this.selectedPlatform,
            filterState: this.selectedFilterState,
          },
          product_filter: this.comparisonList.map((compareBrand) => {
            return {
              selectedBrand: compareBrand.selectedBrand,
            };
          }),
          view_name: this.newViewName,
        },
      };

      if (this.viewModalName === "Edit View") {
        payload = {
          ...payload,
          view_id: this.selectedView.view_id,
        };
      }

      if (
        this.viewModalName === "Save View" &&
        this.selectedModalView.view_id !== "add_new"
      ) {
        (payload.view_data.view_name = this.selectedModalView.view_name),
          (payload = {
            ...payload,
            view_id: this.selectedModalView.view_id,
          });
      }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.getSavedViews();
          this.spinLoader = false;
        })
        .catch((err) => {
           this.$bvToast.toast(err.body.msg, {
              title: "Save Error",
              variant: "danger",
              solid: true,
              toaster: "b-toaster-top-right",
              autoHideDelay: 3000,
              appendToast: true,
          });
          // console.log(`Error in saving view::${err}`);
          this.spinLoader = false;
        });
    },
    resetSavedView() {
      this.selectedView = "";
      this.resetComparisonList();
      this.showArrow = false;
      if ($.fn.DataTable.isDataTable("#sentiment-comp-table-0")) {
        $("#sentiment-comp-table-0").DataTable().clear().destroy();
      }
      this.$nextTick(() => {
        this.getCompareBrandsData(0);
      });
    },
    deleteView() {
      const url = "/api/v2/reviews/comparison_view";
      let payload = {
        view_id: [this.selectedView.view_id],
        view_for: "brand_reviews_compare",
      };

      this.spinLoader = true;
      this.$http
        .delete(url, { body: payload })
        .then((res) => {
          this.getSavedViews();
          this.resetSavedView();

          this.$bvToast.toast("View deleted successfully", {
            title: "Delete View",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });

          this.spinLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast("Error in deleting this view", {
            title: "Delete View",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });
          this.spinLoader = false;
        });

      this.showDeleteModal = false;
    },
    getSelectedSavedView() {
      this.savedViewLoader = true;
      this.comparisonList = [];

      const targetView = this.savedViews.find(
        (view) => view.view_id === this.selectedView.view_id
      );

      this.dateRange = targetView.page_filter.dateRange;
      this.selectedFilterState = targetView.page_filter.filterState;
      this.selectedPlatform = targetView.page_filter.selectedPlatform;
      this.showArrow = targetView.product_filter.length < 5 ? true : false;

      const compareBrandPayload = [];

      targetView.product_filter.map((brand, index) => {
        this.prepareComparisonList(brand.selectedBrand, false);
        this.comparisonList[index].isLoading = true;
        this.getBrandImage(brand.selectedBrand, index);
        compareBrandPayload.push({
          brand_name: brand.selectedBrand,
        });
        if ($.fn.DataTable.isDataTable(`#sentiment-comp-table-${index}`)) {
            $(`#sentiment-comp-table-${index}`).DataTable().clear().destroy();
        }
        // $(`#sentiment-comp-table-${index}`).DataTable().destroy();
      });

      this.$nextTick(() => {
        const url = "/api/v2/indian_clients/compare_data";
        const payload = {
          start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
          client: this.client,
          channel: this.selectedPlatform.platform_id,
          compare: compareBrandPayload,
          compare_type: "brand",
          positive_limit: 50,
          negative_limit: 50,
        };

        this.reviewsLoader = true;

        this.$http
          .post(url, payload)
          .then((res) => {
            this.reviewsLoader = false;
            this.comparisonList.forEach((brand, index) => {
              this.comparisonList[index].isLoading = false;
              this.comparisonList[index].performanceData =
                res.body.data[brand.selectedBrand].reviews.performance_ratings;
              this.comparisonList[index].ratingsData =
                res.body.data[brand.selectedBrand].reviews.ratings;
              this.comparisonList[index].wordCloudData =
                res.body.data[brand.selectedBrand].sentiment.word_clowd;
              this.comparisonList[index].sentimentsCount =
                res.body.data[brand.selectedBrand].sentiment.sentiment;
              this.comparisonList[index].sentimentsTable =
                res.body.data[brand.selectedBrand].sentiment.table;

              this.$nextTick(() => {
                 if ($.fn.DataTable.isDataTable(`#sentiment-comp-table-${index}`)) {
                      $(`#sentiment-comp-table-${index}`).DataTable().clear().destroy();
                  }
                this.processTable(`#sentiment-comp-table-${index}`);
              });
            });
          })
          .catch((err) => {
            this.reviewsLoader = false;
            this.comparisonList.forEach((brand, index) => {
              this.comparisonList[index].isLoading = false;
            });
            console.log("Error in getting compare brand data", err);
          });
        this.savedViewLoader = false;
      });
    },
    downloadReviews() {
      this.reviewsLoader = true;
      const url = "/api/v2/reviews/brand";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform.platform_id,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.reviewsLoader = false;
          window.location = res.body.data.file_url;
        })
        .catch((err) => {
          this.$bvToast.toast("Error in downloading reviews", {
            title: "Download Reviews",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });
          console.log("Error in downloading report", err);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.insight-container {
  padding: 6px 12px;
  margin-block: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
}

.review-heading {
  display: grid;
  align-items: center;

  & > * {
    grid-column: 1;
    grid-row: 1;
  }
}

.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid #e4e7ea;
  width: 220px;
  outline: none;
  font-family: "poppins";
  width: 100%;
}

.customInput:focus {
  border: 1px solid var(--primary_brand) !important;
  box-shadow: none !important;
}

.delete-viewBtn:hover {
  background-color: #f58181 !important;
}

.delete-alert {
  background-color: #ffecec !important;
  color: var(--red);
  font-size: 30px;
  width: 45px;
  height: 45px;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  text-transform: capitalize;
}

.grayedHeading {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--base_color-60) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  text-transform: capitalize;
}

.newComparisonIcon svg {
  height: 17px;
  transform: rotate(45deg);
  color: white;
  fill: #fff;
  margin-right: 5px;
}

.close-card {
  position: absolute;
  right: 20px;
  top: 5px;
  background-color: #dedede;
  padding: 6px 10px;
  border-radius: 50%;
  cursor: pointer;
}

.close-card:hover {
  background-color: #f0f0f0;
}

.scroll-arrow-container {
  margin-top: 40vh;
  height: 50px;
  min-width: 50px;
  cursor: pointer;
}

.scroll-arrow {
  width: 100%;
  height: 100%;
  border: 2px dashed #5e5e5e;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e5e5e;
  border-radius: 50%;
}

.compare-card {
  background-color: white;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  height: 100%;
}

.add-comparison {
  border: 1px solid #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  min-height: 200px;
  border-radius: 10px;
  color: #5e5e5e;
}

.plus-icon {
  font-size: 30px;
  color: #5e5e5e;
  border: 2px dashed #5e5e5e;
  border-radius: 50%;
  padding-inline: 12px;
  cursor: pointer;
}

button.navigation-btn {
  background: var(--accent_color);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.navigation-btn:hover {
  background: var(--accent_color-80);
}

button.navigation-btn:focus,
button.primaryColor:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.customselect {
  height: 37px !important;
  border-radius: 5px !important;
  background: white;
  border: 1px solid #b7b7b7;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}

.modal-control-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d4d4d4;

  & > ul {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
    padding: 0;

    & > li {
      padding-bottom: 16px;
      margin: 0;
      font-size: 16px;
      cursor: pointer;
    }

    & > li.selected-tab {
      border-bottom: 1px solid #065559;
      margin-bottom: -1px;
      color: #065559;
      font-weight: 500;
    }
  }
}

a,
.keyword {
  color: #0463ba !important;
  font-family: Poppins !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 25px !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.label {
  font-size: 14px;
  font-weight: 500;
  color: #1e1e1e;
}

.section-button {
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #065559;
  background-color: transparent;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.04px;
  color: #00555a;
}

.active-button {
  background-color: #065559;
  color: white;
}

.section-card {
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  background-color: transparent;
  padding: 8px 16px;
  height: 100%;
}

.gap {
  gap: 14px !important;
}

.logo-container {
  border-radius: 10px;
  border: 0px solid #d9d9d9;
  background: linear-gradient(
    360deg,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  box-shadow: 0px 1px 6px 0px #0000002e;
  height: 220px;
  max-width: 100%;
}

.logo-container img {
  width: 80%;
}

.horizontal-divider {
  border-bottom: 1px solid #d9d9d9;
}

.vertical-divider {
  border-right: 1px solid #d9d9d9;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.customSelect :focus {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 600;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}
</style>
<style>
/* datatable */
.dataTables_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -15px;
  background-color: var(--primary_brand);
}
.dataTables_filter input{
  border:1px solid #065559 !important;
}

.dataTables_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

table.dataTable th {
  background-color: #e7eeef !important;
  padding: 16px 32px !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

table.dataTable > thead > tr:first-child > th:first-child {
  border-top-left-radius: 5px !important;
}

table.dataTable > thead > tr:first-child > th:last-child {
  border-top-right-radius: 5px !important;
}

table.dataTable > tbody > tr > td {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: black !important;
}

thead {
  background: none !important;
}

.dataTables_info {
  position: relative;
  top: 9px;
  left: 0;
  z-index: 100;
  float: none;
  width: auto;
  font-size: 15px;
  color: var(--primary_brand-80);
}

.dataTables_paginate {
  position: relative;
  top: 6px;
  z-index: 100;
  float: right;
  /* width: 50vw; */
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.thin-scrollerBar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 6px;
  background: #ebedee;
}

.thin-scrollerBar::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.thin-scrollerBar::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

.thin-scrollerBar::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}

.inSightsContainer {
  border-radius: 5px !important;
  border: 1px solid #d9d9d9;
}

.inSightsContainer > div:first-child {
  border-right: 1px solid #d9d9d9;
}

.insightsContent {
  font-weight: 400;
  font-size: 14px;
  color: #1e1e1e;
}

#brand-reviews .containerOverflowClass {
  width: 100%;
  overflow-x: none !important;
}
</style>
